const parse_error = err => {
  if (!err
    || !err.response
    || !err.response.data
    || !err.response.data.error) {
    return err;
  };
  const { error } = err.response.data;
  return error;
};

export default function (error_catcher) {
  let cleanup = () => {
    if (error_catcher) error_catcher(null);
  };
  const _error_catcher = error_catcher || console.error;

  return (async_func, final) => {
    if (typeof cleanup === "function") cleanup();

    return Promise.resolve(async_func())
      .catch(error => {
        cleanup = _error_catcher(parse_error(error)) || cleanup;
      }).finally(() => {
        final && final();
      });
  };
};